import React, { useEffect, useState } from "react";
import "../css/detailProduct.css";
import CustomCard from "../components/CustomCard";
// import useFetch from '../hooks/useFetch';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchProduct } from "../store/action";
import { toIDR } from "../helpers";

export default function DetailProduct() {
  const { id } = useParams();
  const dispatch = useDispatch();
  // useFetch(`http://localhost:3001/Product/${id}`, 'product');
  // useFetch('http://localhost:3001/Images', 'images');
  const { product } = useSelector((state) => state.productReducer);
  const { isLoading } = useSelector((state) => state.globalReducer);

  useEffect(() => {
    dispatch(fetchProduct(id));
  }, []);

  return (
    <div id="detailProduct">
      <div className="container">
        <div className="dp-row">
          <div className="dp-left-col">
            <div className="custom-grid-container-detail">
              <CustomCard load={isLoading} product={product} key={'product-images-0'} detail={false} />
              {
                product?.Images.map(image => {
                  return (
                    <CustomCard load={isLoading} product={image} key={'product-images-' + image.id} detail={false} />
                  )
                })
              }
            </div>
          </div>
          <div className="dp-right-col">
            <div className="detail-title mb-3">
              {
                !isLoading ?
                  product?.name
                  :
                  <Skeleton style={{ height: '40px' }} />
              }
            </div>
            <p className="mb-0" style={{ fontFamily: 'Bebas Neue', color: '#5b5959' }}>
              {
                !isLoading ?
                  product?.SubCategory.Category.name + ' ~ ' + product?.SubCategory.name
                  :
                  <Skeleton style={{ height: '100%' }} />
              }
            </p>
            <p className="mb-3" style={{ fontFamily: 'Bebas Neue', fontSize: '18px', color: '#5b5959' }}>
              {
                !isLoading ?
                  toIDR(product?.price)
                  :
                  <Skeleton style={{ height: '100%' }} />
              }
            </p>
            <p>
              {
                !isLoading
                  ? product?.description
                  : <Skeleton count={10} />
              }
            </p>
            <div className="custom-btn-2-container">
              <button className="btn custom-btn-2">Add to Bag</button>
              <button className="btn custom-btn-2">
                Favourite
                <span className="material-symbols-outlined">favorite</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}